module.exports = __webpack_public_path__ + "img/sole-qrcode-sample.db3545fd.png";